import { render } from "./technology.vue?vue&type=template&id=58de6380"
import script from "./technology.vue?vue&type=script&lang=js"
export * from "./technology.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__